var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCableType = function SvgCableType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#cableType_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.572.857h5.143a1.714 1.714 0 0 1 1.714 1.715v16.285a4.286 4.286 0 0 1-8.572 0V2.572A1.714 1.714 0 0 1 2.572.857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.43 8.572 6-6.034a1.714 1.714 0 0 1 2.416 0l3.617 3.634a1.714 1.714 0 0 1 0 2.417L8.178 21.892"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.43 14.571h6a1.714 1.714 0 0 1 1.714 1.715v5.142a1.714 1.714 0 0 1-1.715 1.715H5.144M.857 7.715H9.43M.857 14.571H9.43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cableType_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCableType;